<template>
  <div>行程</div>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  create(){
    console.log(this,'000')
  },
  mounted() {
  },
}
</script>

<style scoped>

</style>
